import React from 'react';
import ImunologiaPage from './imunologia.page';
function Imunologia () {
  return <ImunologiaPage />;
}

export default Imunologia;



// WEBPACK FOOTER //
// ./src/pages/imunologia/imunologia.container.js